import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ArrowRight } from "@mui/icons-material";
import { arrowTypographyStyles } from "../../../HighPerformancePacker/CategoryDetail/style";
import DataTools from "../../../DataTools/DataTools";

const Description = () => {
  const displayedTool = DataTools.find((tool) => tool.id === parseInt(9));
  if (!displayedTool) {
    return <div>Tool not found</div>;
  }
  return (
    <Box>
      <Stack spacing={2} useFlexGap>
        <Typography
          variant="h1"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignSelf: "center",
            textAlign: "center",
            fontSize: "clamp(1rem, 10vw, 2rem)",
          }}
          // sx={arrowTypographyStyles}
        >
          JM Premium screen
        </Typography>
        <Typography
          variant="h3"
          sx={{
            ...arrowTypographyStyles,
            paddingLeft: { xs: "0", md: "15px" }, // Add paddingLeft for different screen sizes
          }}
        >
          Tool Description
        </Typography>
        <Typography variant="h5" sx={{ paddingLeft: { xs: "0", md: "40px" } }}>
          Mechanics and Features
        </Typography>
        <Typography
          textAlign="justify"
          color="text.secondary"
          sx={{
            alignSelf: "start",
            width: { sm: "100%", md: "100%" },
            paddingLeft: { xs: 0, md: "50px" }, // Set paddingLeft to 50px on md and above
            paddingRight: { xs: 0, md: "30px" }, // Set paddingRight to 30px on md and above
            // fontWeight: "bold",
          }}
          paragraph
        >
          The JM Premium Screen is a whole-welded stainless steel premium
          screen, consisting of a base pipe, composited sand-control filter
          sleeve, and an external protection stainless steel sleeve from inside
          to outside. API standard oil pipe or casing is applied as the base
          pipe. The sand-control filter sleeve is totally welded after rolling
          and shaping of stainless steel mat mesh with different filter pores.
          The whole-welded stainless steel premium screen holds an excellent
          sand control performance due to the features of composited
          sand-control filter sleeve including high permeability, intensity,
          transmogrification property, reliability, and erosion resistance, etc.
          The whole-welded stainless steel premium screen is a new efficient
          sand control tool to take place of former sand control screens.
        </Typography>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            paddingLeft: { xs: 0, md: "50px" },
            paddingRight: { xs: 0, md: "30px" },
          }}
        >
          <ArrowRight />
          <Typography>
            Composited filter layer weaved with multi-layer stainless steel to
            supply a high reliability of sand control.
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            paddingLeft: { xs: 0, md: "50px" },
            paddingRight: { xs: 0, md: "30px" },
          }}
        >
          <ArrowRight />
          <Typography>
            Strong resistance to extrusion deformation and bending deformation.
            The sand control ability remains unchanged when the radial
            deformation is 40%, which satisfies the demand of horizontal wells.
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            paddingLeft: { xs: 0, md: "50px" },
            paddingRight: { xs: 0, md: "30px" },
          }}
        >
          <ArrowRight />
          <Typography>
            Large filtration area, low flowing resistance and high production
            capability.
          </Typography>
        </Stack>

        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            paddingLeft: { xs: 0, md: "50px" },
            paddingRight: { xs: 0, md: "30px" },
          }}
        >
          <ArrowRight />
          <Typography>
            Filtration pore size can control at high accuracy (error is less
            than 10 um); filtration pore is stable without deformation.
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            paddingLeft: { xs: 0, md: "50px" },
            paddingRight: { xs: 0, md: "30px" },
          }}
        >
          <ArrowRight />
          <Typography>
            Filtration pore is uniform with high permeability and high ability
            of blocking protection. The blockage period is 2~3 times as long as
            conventional screen, and and it is easy to reverse circulate to wash
            well.
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            paddingLeft: { xs: 0, md: "50px" },
            paddingRight: { xs: 0, md: "30px" },
          }}
        >
          <ArrowRight />
          <Typography>
            Standard oil pipe or casing is used as base pipe. Filtration layer
            is made of high-quality stainless steel, which has high corrosion
            resistance. The filtration layer is resistent to corrosion of
            CO2、Cl-、H2S, thus is applicable to acid operation.
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            paddingLeft: { xs: 0, md: "50px" },
            paddingRight: { xs: 0, md: "30px" },
          }}
        >
          <ArrowRight />
          <Typography>
            Small outer diameter and light weight make it easy to run in hole on
            long horizontal sections.
          </Typography>
        </Stack>

        {/* <Typography
          variant="h5"
          sx={{
            // fontFamily:"calibri",
            paddingLeft: { xs: "0", md: "40px" }, // Adjust the margin-left for different screen sizes
          }}
        >
          Application
        </Typography>
        <Typography
          textAlign="justify"
          color="text.secondary"
          sx={{
            alignSelf: "start",
            width: {
              sm: "100%",
              md: "100%",
              textIndent: "29px",
              padding: "0px 30px 0px 30px",
            },
          }}
          paragraph
        >
          The Model ‘IP’ Isolation Packer is mainly used to isolate zones ,
          which is compatible with RF-Model‘HR’ Packer or other tools to be used
          for layered water location, layered water shutoff, layered
          acidification, layered sand control and layered production operations.
          <br />
        </Typography> */}
        {/* <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ paddingLeft: "50px" }}
        >
          <ArrowRight />
          <Typography>Pressure Grade：10000psi</Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ paddingLeft: "50px" }}
        >
          <ArrowRight />
          <Typography>Temperature Rating：0—180°C</Typography>
        </Stack> */}
      </Stack>
      <Box
        sx={{
          width: "100%", // Set the width of the outer box
          //maxWidth: '140px', // Set the maximum width of the outer box
          display: "flex",
          justifyContent: "center", // Center the content horizontally
          flexWrap: "wrap", // Allow the content to wrap if needed
          //backgroundColor: 'green',

          mt: 2, // Add margin at the top
        }}
      >
        <img
          src={displayedTool.image}
          alt={`Swellable Packer Tool`}
          style={{
            width: "100%", // Set the width of the image
            maxWidth: "466px",
            height: "auto", // Automatically adjust the height based on the width
            // display: 'inline-block', // Ensure the image is displayed as an inline block
          }}
        />
      </Box>
      <Typography
        variant="h5"
        textAlign="start" // Align text to the start (left)
        sx={{ mt: "30px", paddingLeft: { xs: "0", md: "40px" } }}
      >
        Technical Parameters
      </Typography>
    </Box>
  );
};

export default Description;
